import React from "react";

function CartFilters({ type, price = "", color = "", size = "" }) {
  return (
    <div className="mb-2 flex gap-2 text-sm">
      <span className="text-lg font-semibold uppercase md:text-base">
        {type}
      </span>
      <span className="text-lg font-light capitalize md:text-base">
        {price || color || size}
      </span>
    </div>
  );
}

export default CartFilters;
